import { useEffect } from 'react'
import { useHeroNavbar } from '@/context/hero-navbar-context'
import { Main } from '@/components/layout/main'
import { columns } from './components/columns'
import { DataTable } from './components/data-table'
import { TasksDialogs } from './components/tasks-dialogs'
import { TasksPrimaryButtons } from './components/tasks-primary-buttons'
import TasksProvider from './context/tasks-context'
import { tasks } from './data/tasks'

export default function Tasks() {
  const { setHeading, setVariant, setBreadcrumbs } = useHeroNavbar()
  useEffect(() => {
    setHeading(
      <h1 className='tracking-tigh text-2xl font-bold md:text-3xl'>
        <span className='text-[#D92D20]'>M</span>
        <span>odules</span>
      </h1>
    )
    setVariant('pattern')
    setBreadcrumbs([])
  }, [setHeading, setVariant, setBreadcrumbs])
  return (
    <TasksProvider>
      <Main className='pt-4'>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Tasks</h2>
            <p className='text-muted-foreground'>
              Here&apos;s a list of your tasks for this month!
            </p>
          </div>
          <TasksPrimaryButtons />
        </div>
        <div className='-mx-4 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <DataTable data={tasks} columns={columns} />
        </div>
      </Main>

      <TasksDialogs />
    </TasksProvider>
  )
}
